import React, { useEffect, useState } from "react";
import PaymentOptions from "./PaymentOptions";
import SelectedPayment from "./SelectedPayment";
import WithdrawalPayments from "./WithdrawalPayments";
import DepositWithdrawForm from "./DepositWithdrawForm";
import { cn } from "helper/Utils";
import { WITHDRAWL_PAYMENT_OPTIONS } from "config/DATA";

const Withdraw = () => {
  const [isMobile, setIsMobile] = useState(window?.innerWidth <= 768);
  const [selectedPayment, setSelectedPayment] = useState(null);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    if (!isMobile) {
      setSelectedPayment(WITHDRAWL_PAYMENT_OPTIONS[0]);
    }

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onSubmit = async (data) => {
    window.location.href = "https://direct.lc.chat/19082120/";
  };
  if (!isMobile && !selectedPayment) {
    return <div className="py-10 text-center text-white/70 text-[12px]">There are no payment options for selected type</div>;
  }
  return (
    <div className="h-screen max-h-[calc(100vh-200px)] overflow-y-auto">
      <div className="p-1 pb-[20px]">
        <PaymentOptions options={WITHDRAWL_PAYMENT_OPTIONS} selectedPayment={selectedPayment} setSelectedPayment={setSelectedPayment} />
        <div
          className={cn(
            "md:bg-white/5 p-[20px] md:rounded w-full md:relative fixed left-0 bg-body z-100 transition-all duration-300 ",
            isMobile ? (selectedPayment ? "translate-x-0 top-0 h-screen" : "translate-x-full") : null
          )}
        >
          <>
            <div className={cn("md:hidden items-center -mt-2 -ml-2 gap-2  sm:text-[16px] text-sm leading-none", selectedPayment ? "flex" : "hidden")}>
              <i
                className={cn(
                  "bc-i-small-arrow-left flex justify-center items-center h-5 w-5 text-[10px] leading-none rounded-full bg-white bg-opacity-60 text-body"
                )}
                onClick={() => setSelectedPayment(null)}
              />{" "}
              {selectedPayment?.title}
            </div>
            <div className="md:m-0 -m-2 mt-2">
              <SelectedPayment selectedPayment={selectedPayment} />
              <WithdrawalPayments />
              <DepositWithdrawForm onSubmit={onSubmit} />
              <p className="mt-[10px] py-[10px] text-[14px] text-[rgb(255,255,255,.6)]">
                For making a withdraw, please fill in all the mandatory fields above.
              </p>
            </div>
          </>
        </div>
      </div>
    </div>
  );
};
export default Withdraw;
